/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-08-23 15:43:48
 * @LastEditTime: 2019-09-11 14:47:15
 * @LastEditors: yingbin
 */
import * as types from './mutation-types'
const mutations = { 
    [types.USER_INFO](state, userInfo) {
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
        state.userInfo = userInfo
    },
     [types.CREATE_INFO](state, createInfo) {
         sessionStorage.setItem('createInfo', JSON.stringify(createInfo))
         state.createInfo = createInfo
     },
    [types.IS_AUTH](state, isAuth) {
        sessionStorage.setItem('isAuth', isAuth)
        state.isAuth = isAuth;
    }

}
export default mutations